import { render } from "./FlashMessage.vue?vue&type=template&id=6eb05740&scoped=true&ts=true"
import script from "./FlashMessage.vue?vue&type=script&lang=ts"
export * from "./FlashMessage.vue?vue&type=script&lang=ts"

import "./FlashMessage.vue?vue&type=style&index=0&id=6eb05740&scoped=true&lang=scss"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb05740"]])

export default __exports__